import { render, staticRenderFns } from "./config_save.vue?vue&type=template&id=2f87cefc&"
import script from "./config_save.vue?vue&type=script&lang=js&"
export * from "./config_save.vue?vue&type=script&lang=js&"
import style0 from "./config_save.vue?vue&type=style&index=0&id=2f87cefc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VSpacer,VTextField,VTextarea,VToolbar})
